module.exports = __webpack_public_path__ + "static/media/BecauseThingsHappen.dd5d05f4.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/assets/resources/SHS-ASURION/BecauseThingsHappen.svg
// module id = 1379
// module chunks = 0